<template>
  <div class="file-viewer-article-wrapper" :class="{ maximized }">
    <div ref="contentWrapper" class="content-wrapper">
      <div
        ref="articleContent"
        class="article-content"
        @wheel.stop.prevent="onMouseWheel"
      >
        <h3 class="title font-26">{{ viewFile.title }}</h3>
        <div class="author font-13 font-color-notice">
          <span>作者：</span>{{ viewFile.author }}
        </div>
        <div class="description font-14 font-color-other">
          {{ viewFile.description }}
        </div>
        <div class="body">
          <DetailWidgets :content-info="viewFile"></DetailWidgets>
        </div>
      </div>
    </div>
    <button
      v-if="!maximized && isLogin"
      class="fullscreen-btn"
      @click="$emit('maximize')"
    >
      <i class="iconfont icon-quanping"></i>
    </button>
    <div v-if="maximized" class="restore-button" @click="$emit('restore')">
      <i class="iconfont icon-guanbianniu"></i>
    </div>
    <div v-if="maximized" class="scroll-top-btn" @click="toTop">
      <i class="iconfont icon-xiangshangjiantou"></i>
    </div>
    <div v-show="!isLogin && loginShow" class="login-content">
      <p>
        查看完整内容，请
        <span class="highlight" @click="loginModalToggle(true)">
          立即登录案例库
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import DetailWidgets from '@/components/widget/DetailWidgets'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    DetailWidgets
  },
  props: {
    viewFile: {
      type: Object,
      default: () => ({})
    },
    maximized: Boolean
  },
  data() {
    return {
      articleScrollTop: 0,
      loginShow: false
    }
  },
  computed: {
    ...mapState(['isLogin'])
  },
  methods: {
    onMouseWheel(e) {
      const { contentWrapper, articleContent } = this.$refs
      let deltaY = e.deltaY || e.wheelDeltaY || 5
      const scroll = this.articleScrollTop + deltaY
      const containerHeight = contentWrapper.clientHeight
      const contentHeight = articleContent.clientHeight
      if (contentHeight < containerHeight) return
      if (scroll <= 0) {
        this.articleScrollTop = 0
      } else if (scroll > containerHeight * 2 && !this.isLogin) {
        this.loginShow = true
      } else if (scroll > contentHeight - containerHeight) {
        this.articleScrollTop = contentHeight - containerHeight
      } else {
        this.articleScrollTop = scroll
      }
      contentWrapper.scrollTop = this.articleScrollTop
      this.$Lazyload.lazyLoadHandler()
    },
    toTop() {
      const self = this
      const { contentWrapper } = this.$refs
      let cur = this.articleScrollTop
      const duration = 1
      const step = 100
      _top()

      function _top() {
        cur -= step
        self.articleScrollTop = cur
        contentWrapper.scrollTop = cur
        if (cur > 0) {
          setTimeout(_top, duration)
        } else {
          self.articleScrollTop = 0
        }
      }
    },
    ...mapMutations(['loginModalToggle'])
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-article-wrapper {
  background-color: #000000;
  height: 100%;
  position: relative;
  .content-wrapper {
    height: 100%;
    overflow: hidden;
  }
  .article-content {
    padding: 32px 48px;
  }
  .detail-widgets-wrapper {
    background-color: #000000;
    color: #ffffff;
  }
  .title {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
    margin-bottom: 16px;
  }
  .author {
    margin-bottom: 32px;
  }
  .description {
    padding: 12px 24px 12px 16px;
    border-left: 4px solid #8e9091;
    background-color: rgba(255, 255, 255, 0.15);
    margin-bottom: 24px;
  }
  .fullscreen-btn,
  .scroll-top-btn {
    width: 40px;
    height: 40px;
    background-color: rgba(54, 54, 54, 0.85);
    color: #ffffff;
    border: none;
    outline: none;
    border-radius: 0;
    cursor: pointer;
    position: absolute;
    right: 24px;
    bottom: 12px;
    z-index: 11;
    &:hover {
      background-color: #3352fe;
      .tooltip {
        display: block;
      }
    }
    i {
      font-size: 22px;
    }
  }
  .scroll-top-btn {
    width: 44px;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
  .restore-button {
    position: absolute;
    top: 32px;
    right: 32px;
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    color: #363636;
    background-color: rgba(142, 144, 145, 0.85);
    z-index: 10;
    cursor: pointer;
    i {
      font-size: 35px;
    }
    &:hover {
      background-color: #3352fe;
      color: #ffffff;
    }
  }
  .login-content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 84%);
    color: #d5dce6;
    text-align: center;
    font-size: 16px;
    z-index: 12;
    .highlight {
      color: #f8633b;
      cursor: pointer;
    }
  }
  &.maximized {
    .article-content {
      padding: 32px 128px;
    }
  }
}
</style>
